import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared";

import { CommunityEditorComponent } from "./community-editor.component";
import { EditableCommunityResolver } from "../../../shared/services";
import { CommunityEditorRoutingModule } from "./community-editor-routing.module";

@NgModule({
  imports: [CommunityEditorRoutingModule, SharedModule],
  declarations: [CommunityEditorComponent],
  providers: [EditableCommunityResolver],
})
export class CommunityEditorModule {}
